<template>
  <div class="empty-state" :class="{ compact }">
    <q-icon 
      :name="icon" 
      :size="compact ? '1.5rem' : '3rem'" 
      :color="iconColor"
    />
    <div v-if="title" class="empty-title">{{ title }}</div>
    <div v-if="description && !compact" class="empty-description">{{ description }}</div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  
  props: {
    icon: { type: String, default: 'search_off' },
    iconColor: { type: String, default: 'grey-5' },
    title: { type: String, default: '' },
    description: { type: String, default: '' },
    compact: { type: Boolean, default: false }
  }
}
</script>

<style lang="scss" scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  gap: 0.5rem;
  text-align: center;

  &.compact {
    padding: 0.75rem;
    gap: 0.25rem;
  }
}

.empty-title {
  font-size: 1rem;
  font-weight: 500;
  color: $grey-7;

  body.body--dark & {
    color: $grey-5;
  }

  .compact & {
    font-size: 0.75rem;
  }
}

.empty-description {
  font-size: 0.875rem;
  color: $grey-6;
  max-width: 20rem;
  line-height: 1.4;

  body.body--dark & {
    color: $grey-6;
  }
}
</style>